// import UnknownResult from './views/unknown'
// import SummaryResult from './views/summaryv2'
// import NextResult from './views/next'
// import TDNextResult from './views/tdnext'
import WiremapResult from '../views/wiremap'
// import FiberResult from './views/fiber'
import TabularSubtest from './views/lfttest'
import RFSubtest from './views/rftest'

const ResultMap = {
  'Wiremap': WiremapResult,
  'Length': TabularSubtest,
  'HeadRoom': TabularSubtest,
  'DelaySkew': TabularSubtest,
  'PropagationDelay': TabularSubtest,
  'Resistance': TabularSubtest,
  'ResistanceUnBalancedPair': TabularSubtest,
  'Capacitance': TabularSubtest,
  'Impedance': TabularSubtest,
  'NEXT': RFSubtest,
  'PSNEXT': RFSubtest,
  'ACRF': RFSubtest,
  'PSACRF': RFSubtest,
  'ATTEN': RFSubtest,
  'RTNLOSS': RFSubtest,
  'ACRN': RFSubtest,
  'PSACRN': RFSubtest,
  'TCL': RFSubtest,
  'ELTCTL': RFSubtest,
  // 'CDNEXT': RFSubtest,
  // 'CMRL': RFSubtest,
  'TDNEXT': RFSubtest,
  'TDRTNLOSS': RFSubtest
 // 'TDR': TabularSubtest
}

const GetThumbnailResultView = (result) => {
  return (ResultMap.hasOwnProperty(result))
    ? ResultMap[result]
    : ResultMap['unknown']
}

export default GetThumbnailResultView
